import React from 'react'
// libs
import styled from 'styled-components'
// hooks
import { useModalData } from 'hooks/index'
// components
import Modal from 'components/UI/Modal'
import { Button, BUTTON_LAYOUTS } from 'components/UI'
import Cropper, { ReactCropperElement } from 'react-cropper'
// constants
import { Modals } from 'constants/modals'

const styles = {
  cropper: {
    height: 300,
    width: '100%'
  }
}

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 20px;
  margin-bottom: 20px;
`

const ImgCropper = () => {
  const { hideModal, modalData } = useModalData({ modalType: Modals.IMAGE_CROPPER_MODAL })

  const cropperRef = React.useRef<ReactCropperElement>(null)

  const handleCloseModal = () => hideModal()

  const getCanvasToBlob = (): Promise<Blob> => {
    const canvas = cropperRef.current?.cropper.getCroppedCanvas()

    return new Promise((resolve) => {
      canvas.toBlob((file) => {
        resolve(file)
      }, 'image/jpeg')
    })
  }

  const handleCropClick = async () => {
    const blobCanvas = await getCanvasToBlob()
    const urlCreator = window.URL || window.webkitURL
    const imageUrl = urlCreator.createObjectURL(blobCanvas)

    modalData.handleCropImage?.(blobCanvas, imageUrl)
    handleCloseModal()
  }

  return (
    <Modal isOpen={modalData.isOpen} width={modalData.width} hideModal={handleCloseModal}>
      <Cropper ref={cropperRef} src={modalData.image} style={styles.cropper} initialAspectRatio={1} />
      <ButtonWrapper>
        <Button onClick={handleCropClick} layout={BUTTON_LAYOUTS.PURPLE}>
          Update Profile Picture
        </Button>
      </ButtonWrapper>
    </Modal>
  )
}

export default ImgCropper
